import React, { useState } from "react";
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { FaLinkedinIn, FaGithub, FaMedium } from "react-icons/fa";
import { logo } from "../../assets/index";
import { navLinksdata } from "../../constants";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <div className="w-full h-24 sticky top-0 z-50 bg-bodyColor mx-auto flex justify-between items-center font-titleFont border-b-[1px] border-b-gray-600">
      <div className="flex flex-row items-center justify-center gap-5">
        <div className="border-b-2 border-b-gray-600 rounded-full w-14">
          <img src={logo} alt="logo" />
        </div>
        <p className="lg:text-2xl md:text-xl text-lg">
          Shr<span className="text-red-500">avan Bobade</span>
        </p>
      </div>
      <div className="flex flex-row gap-5">
        <div className="flex gap-5">
          <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
            {navLinksdata.map(({ _id, title, link }) => (
              <li
                className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                key={_id}
              >
                <Link
                  activeClass="active"
                  to={link}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-3">
            <a
              href="/resume/Shravan Bobade.pdf"
              download="Shravan Bobade.pdf"
              target="_blank"
            >
              <button className="bg-button-gradient transition-all py-[11px] px-[12px] md:bg-gradient-to-t md:from-transparent md:to-transparent shadow-lg border-0 text-sm focus:outline-none cursor-pointer flex items-center gap-3 rounded hover:scale-105">
                <span className="w-24 lg:w-full text-white">Download CV</span>
                <svg
                  stroke="currentColor"
                  fill="none"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-fit transition-all cursor-pointer text-lg lg:text-2xl animate-bounce text-red-500"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"></path>
                  <path d="M12 13l0 9"></path>
                  <path d="M9 19l3 3l3 -3"></path>
                </svg>
              </button>
            </a>
          </div>
        </div>
        <span
          onClick={() => setShowMenu(!showMenu)}
          className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
        >
          <FiMenu />
        </span>
        {showMenu && (
          <div className="w-[80%] h-screen overflow-scroll absolute top-0 left-0 bg-gray-900 p-4 scrollbar-hide">
            <div className="flex flex-col gap-8 py-2 relative">
              <div>
                <img className="w-32" src={logo} alt="logo" />
                <p className="text-sm text-gray-400 mt-2">
                  I spend my days debugging code and my nights wondering why
                  semicolons are so elusive. When I'm not arguing with my
                  computer, I freelance, turning caffeine into code and bugs
                  into features.
                </p>
              </div>
              <ul className="flex flex-col gap-4">
                {navLinksdata.map((item) => (
                  <li
                    key={item._id}
                    className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                  >
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="flex flex-col gap-4">
                <h2 className="text-base uppercase font-titleFont mb-4">
                  Find me in
                </h2>
                <div className="flex gap-4">
                  <a
                    className="bannerIcon"
                    href="https://github.com/Shravan250"
                  >
                    <FaGithub />
                  </a>
                  <a
                    className="bannerIcon"
                    href="https://medium.com/@shravan.bobade.tech"
                  >
                    <FaMedium />
                  </a>
                  <a
                    className="bannerIcon"
                    href="www.linkedin.com/in/shravan-bobade"
                  >
                    <FaLinkedinIn />
                  </a>
                </div>
              </div>
              <span
                onClick={() => setShowMenu(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-designColor duration-300 text-2xl cursor-pointer"
              >
                <MdClose />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
